// extracted by mini-css-extract-plugin
export default {"avatar":"V8gwZj","withBorder":"CiSb4N","memberInitials":"ZeCqr2","avatarPlaceholder":"aBATL4","loggedOut":"b2cSkJ"};